module.exports = __webpack_public_path__ + "static/media/arrow_curve.61b339ae.svg";